import HoveredButton from "./HoveredButton";

export default class NoFavoritesDiplayBoard extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <div className="no-fav-menu-card-container">
                     <span>
                            {this.props.title}
                     </span>
                    <span>
                         {this.props.subTitle}  
                    </span>
                     <span>
                         <HoveredButton buttonText={this.props.buttonText} />
                    </span>              
                </div>
            </div>   
        );
    }
}

